module.exports = __webpack_public_path__ + "img/noresultados.f9947d5e.png";